import React, { FC } from 'react';
import IComponentProps from 'interfaces/IComponentProps';
import Modal from 'components/Modal';
import Frame from 'components/Frame';
import { useHistory } from 'react-router-dom';

const ErrorPage:FC<IComponentProps> = (props) => {
  const history = useHistory();
  return(
    <Frame className='bg'>
      <Modal
        open={true}
      >
        <div>
          진행 중 오류가 발생하여 첫 화면으로 이동합니다.
        </div>
        <button
          className='btn-cta'
          onClick={()=>history.replace('/')}
        >
          확인
        </button>
      </Modal>
    </Frame>
  )
}

export default ErrorPage;